import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import PositionForm from '../Form';
import { createPosition } from '@resources/Position/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createPosition, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createPosition(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.position.create',
						defaultMessage:
							'A new Position has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.position',
					defaultMessage: 'Create Position',
				})}
			</Title>
			<Section className="mb-5">
				<PositionForm onSubmit={handleSubmit} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createPosition,
})(Create);
